import request from '@/utils/request'

// 获取应用菜单
export const getAppMenuListApi = (code) => request({
  url: '/bd/operation/getUserOperationByCode',
  method: 'get',
  params: { code }
})
// 获取配置信息
export const getConfigInfoApi = (settingKey) => request({
  url: '/setting/getSettingByKey',
  method: 'get',
  params: { settingKey }
})

//公共自定义表单组件
// 获取表单项
export const getFormItem = (formId) => request({
  url: '/bd/form/getFormInfo',
  method: 'get',
  params: { formId }
})
// 获取字典列表
export const getDictList = (name) => request({
  url: '/component/dictionary/dict/list',
  method: 'get',
  params: { name }
})
// 获取省市区树
export const getRegionTree = () => request({
  url: '/bd/region/list',
  method: 'get'
})
// 获取字典项列表
export const getDictItemList = (code) => request({
  url: '/component/dictionary/getDictValueByCode',
  method: 'get',
  params: { code }
})
// 更新表单项
export const saveFormItem = (data) => request({
  url: '/bd/form/updateFormField',
  method: 'post',
  data,
  headers: { 'Content-Type': 'application/json' }
})
// 部门列表
export const getDepartmentListApi = () => request({
  url: '/base/department/getDeptTree',
  method: 'get'
})
// 根据用户权限获取部门
export const getUserInfo = (userId) => request({
  url: `/bd/teacher/getUserInfo`,
  method: 'get',
  params: { userId }
})

// 获取级届院系专业班级列表
export const getTreeDataApi = (params) => request({
  url: `/bd/class/getPeriodCollegeMajorClassTree?graduatedFlag=${params}`,
  method: 'get'
})

// 教师列表
export const getTeacherList = (data) => request({
  url: '/bd/teacher/getTeacherList',
  method: 'post',
  data,
  headers: { 'Content-Type': 'application/json' }
})
// 学生列表
export const getStudentList = (data) => request({
  url: '/student/list',
  method: 'post',
  data,
  headers: { 'Content-Type': 'application/json' }
})

// 根据用户权限获取职务
export const getUserPositionApi = (userId) =>
  request({
    url: `/base/position/getUserPosition`,
    method: "get",
    params: { userId },
  });
// 获取所有职务列表
export const getAllPositionsApi = (positionDict) =>
  request({
    url: `/base/position/getPositionList`,
    method: "get",
    params: { positionDict },
  });

